/* You can add your custom scripts here */

/* CRO fixes (Oct 2026) */
(function () {
  var css = [
    /* Mobile menu icon was near-black on the black header */
    '.header-drawer, .header-drawer summary, .header-drawer-toggle, .header-drawer svg { color: #faf9f6 !important; }',
    /* Collection pages: get products on screen sooner on phones */
    '@media (max-width: 749px) {',
    '  .section-collection-banner, .section-collection-banner .page-header-details { min-height: 0 !important; height: auto !important; }',
    '  .section-collection-banner .page-header-details { padding-top: 32px !important; padding-bottom: 32px !important; }',
    '  .section-collection-banner .main-page-header-title { font-size: clamp(30px, 9vw, 40px) !important; line-height: 1.1 !important; hyphens: none !important; word-break: normal !important; overflow-wrap: normal !important; }',
    '  .template-collection .block-trust_bar_heading { font-size: 12px !important; line-height: 1.7 !important; letter-spacing: 0.12em !important; }',
    '}',
    /* Add to Cart label was pale gold on cream; match the gold cart button */
    '.product-add-to-cart, .product-sticky-bar-add-to-cart { background-color: var(--db-gold) !important; color: var(--db-black) !important; border-color: var(--db-gold) !important; font-weight: 600 !important; }',
    '.product-add-to-cart:hover, .product-sticky-bar-add-to-cart:hover { background-color: var(--db-gold-l) !important; }',
    /* Delivery date/time labels were dark on the dark product page */
    '#buunto-date-picker [class*="label"] { color: var(--db-off-white) !important; }',
    /* Grazing tables are priced per guest */
    '.cro-per-guest { font-size: 0.75em; opacity: 0.8; margin-left: 4px; white-space: nowrap; }',
    /* Keep the review popup off the quote form */
    '.template-page.corporate-catering .loox-pn { display: none !important; }'
  ].join('\n');
  var style = document.createElement('style');
  style.id = 'cro-fixes';
  style.textContent = css;
  document.head.appendChild(style);

  /* Quote links pointed at a section id that doesn't exist; send them to the form */
  function quoteSection() {
    return document.querySelector('[id$="__custom_liquid_hbhAxm"]');
  }
  function isQuoteHash(hash) {
    return /custom_liquid_hbhAxm|^#quote$/.test(hash || '');
  }
  function scrollToQuote() {
    var target = quoteSection();
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (isQuoteHash(location.hash)) {
    window.addEventListener('load', function () { setTimeout(scrollToQuote, 300); });
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="#"]');
    if (!link || !isQuoteHash(link.hash) || link.pathname !== location.pathname || !quoteSection()) return;
    e.preventDefault();
    scrollToQuote();
  });

  /* Label per-guest pricing on grazing table cards */
  function labelGrazePrices(root) {
    (root || document).querySelectorAll('.products-list-item').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      var price = card.querySelector('.products-list-item__price');
      if (!link || !price || price.querySelector('.cro-per-guest')) return;
      if (!/-graze(-\d+)?\/?$/.test(link.pathname)) return;
      price.insertAdjacentHTML('beforeend', '<span class="cro-per-guest">/ guest · 25 min</span>');
    });
  }
  /* The delivery date app inserts itself after the description; keep it next to Add to Cart */
  function placeDatePicker() {
    var picker = document.getElementById('buunto-date-picker');
    var buy = document.querySelector('.product-summary .block-buy-buttons');
    if (!picker || !buy || picker.parentElement !== buy.parentElement || picker.nextElementSibling === buy) return;
    buy.parentElement.insertBefore(picker, buy);
  }
  function run() { labelGrazePrices(document); placeDatePicker(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; run(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
